const localStorageKey = "trackingInfo"
const trackingParams = ['pid', 'it']

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = trackingParams

  declare readonly pidTarget: HTMLInputElement
  declare readonly itTarget: HTMLInputElement

  private localStorage!: Storage;

  initialize(): void {
    this.localStorage = window.localStorage;
    const params = (new URL(document.location.href)).searchParams;

    trackingParams.forEach((param) => {
      const queryParam = params.get(param);
      // record on storage only new params
      if (this.localStorage.getItem(localStorageKey) !== queryParam) {
        this.localStorage.setItem(param, params.get(param) || '')
      }
    });
  }

  connect(): void {
    this.pidTarget.value = this.localStorage.getItem("pid") || '';
    this.itTarget.value = this.localStorage.getItem("it") || '';
  }
}
